import { createClient } from '@supabase/supabase-js'

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL?.replace(/"/g, '')
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY?.replace(/"/g, '')

// Custom lock function that doesn't use navigator.locks
const customLock = async (name, acquireTimeout, fn) => {
  return await fn();
};

// Custom fetch that handles body stream issues
const customFetch = (url, options = {}) => {
  return fetch(url, {
    ...options,
    // Ensure body is properly handled
  });
};

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
    lock: customLock,
    storageKey: 'infact999-auth',
  },
  global: {
    fetch: customFetch,
  }
})
